import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.logisticListing || initialState;

export const selectlogistics = createSelector(
  [selectDomain],
  (state) => state.logistics
);
